import React, { useEffect, useState } from 'react';
import api from '../services/api';
import type StudyParticipantModel from '../models/StudyParticipantModel';
import LoadingSpinner from './LoadingSpinner';

type PropTypes = {
    onDocumentCreated: () => void;
    participant: StudyParticipantModel;
};

function CreateStudyDocumentForm({
    onDocumentCreated,
    participant,
}: PropTypes) {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [file, setFile] = useState<File | undefined>();

    useEffect(() => {
        setError('');
    }, [name]);

    const handleSubmit = async () => {
        if (!name || !file) {
            setError('All fields are required');
            return;
        }

        setLoading(true);
        const { success } = await api.createParticipantDocument(
            name,
            file,
            participant.id,
        );
        setLoading(false);
        if (success) {
            onDocumentCreated();
        } else {
            setError('Failed to create document. Please try again later.');
        }
    };

    return (
        <div className="w-[400px]">
            <div className="mt-2 flex items-center justify-between">
                <label>Name:</label>
                <input
                    className="border border-black rounded text-primary p-1 w-1/2"
                    type="text"
                    name="name"
                    value={name}
                    onChange={(event) => {
                        setName(event.target.value);
                    }}
                />
            </div>
            <div className="mt-2 flex items-center justify-between">
                <label>File:</label>
                <input
                    className="text-primary w-1/2"
                    type="file"
                    name="file"
                    onChange={(event) => {
                        if (
                            event.target.files &&
                            event.target.files.length > 0
                        ) {
                            const newFile = event.target.files[0];
                            setFile(newFile);
                            if (!name) {
                                setName(newFile.name);
                            }
                        }
                    }}
                />
            </div>
            {error && <div className="text-red-500 mt-2">{error}</div>}
            <button
                type="submit"
                className="btn btn-primary mt-6"
                disabled={loading || error !== ''}
                onClick={handleSubmit}
            >
                {loading ? <LoadingSpinner size={30} /> : 'Create Document'}
            </button>
        </div>
    );
}

export default CreateStudyDocumentForm;
